import { instance } from '@/utils/client';
import publicApi from '@/api/public';
import reportApi from '@/api/report';

const url = {
  /** research對外網頁api */
  research: process.env.VUE_APP_PUBLIC_URL,
};

/*
  透過 const {login} = this.$api; 把實體取出來
  即可呼叫 login 底下的 API 方法
*/
export default {
  publicApi: publicApi(instance, `${url.research}/api/SimpleReport`), // 公開資訊
  reportApi: reportApi(instance, `${url.research}/api/report`), // 放在對外網頁上的公開資訊
};
